const all = ['projects'] as const;

const findAllForClient = (
  clientId: string,
  take?: number,
  skip?: number
) => [...all, 'client', clientId, take, skip] as const;

const findOne = (projectId: string) => [...all, projectId] as const;

export const projectKeys = {
  all,
  findAllForClient,
  findOne,
};
